import { useGeneralStore } from "../../stores";
import { Color, ObjectId, Tag } from "../../types";
import Api from "../api";

class TagApi extends Api {
  static getTags(): Promise<Array<Tag>> {
    return this.getData("/tag");
  }

  static addTag(name: string, color: Color): Promise<void> {
    return new Promise((resolve, reject) => {
      this.postData<Tag, {}>("/tag", { name, color })
        .then((tag) => {
          useGeneralStore.getState().addTag(tag);
          resolve();
        })
        .catch((err) => reject(err));
    });
  }

  static getTopTags(): Promise<Array<ObjectId>> {
    return new Promise((resolve, reject) => {
      this.getData<Array<{ _id: ObjectId }>>("/tag/top")
        .then((res) => {
          resolve(res.map((t) => t._id));
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}

export default TagApi;
